import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track"]

  connect() {
    this.trackEl = this.trackTarget
    this._fillTrack()

    this.trackEl.addEventListener("mouseenter", () => this.trackEl.style.animationPlayState = "paused")
    this.trackEl.addEventListener("mouseleave", () => this.trackEl.style.animationPlayState = "running")
    this.trackEl.addEventListener("touchstart", () => this.trackEl.style.animationPlayState = "paused", { passive: true })
    this.trackEl.addEventListener("touchend", () => {
      setTimeout(() => this.trackEl.style.animationPlayState = "running", 2000)
    })
  }

  _fillTrack() {
    // Collect original cards (first set only, skip aria-hidden duplicates)
    const allCards = [...this.trackEl.children]
    const originals = allCards.filter(c => c.getAttribute("aria-hidden") !== "true")
    const duplicates = allCards.filter(c => c.getAttribute("aria-hidden") === "true")

    // Remove server-rendered duplicates — we'll clone precisely what we need
    duplicates.forEach(c => c.remove())

    // Measure one set width
    const containerWidth = this.element.offsetWidth
    const oneSetWidth = this.trackEl.scrollWidth

    if (oneSetWidth <= 0) return

    // We need at least 2x container width of content for seamless loop
    const minWidth = containerWidth * 2
    const copiesNeeded = Math.ceil(minWidth / oneSetWidth)

    // Clone sets until we have enough (we already have 1 original set)
    for (let i = 0; i < copiesNeeded; i++) {
      originals.forEach(card => {
        const clone = card.cloneNode(true)
        clone.setAttribute("aria-hidden", "true")
        this.trackEl.appendChild(clone)
      })
    }

    // Set animation duration proportional to content (slower = more readable)
    // ~20px per second equivalent
    const totalWidth = this.trackEl.scrollWidth
    const halfWidth = totalWidth / (copiesNeeded + 1) * copiesNeeded
    const duration = halfWidth / 20
    const percentage = (1 / (copiesNeeded + 1)) * copiesNeeded * 100

    this.trackEl.style.animationDuration = `${duration}s`
    this.trackEl.style.setProperty("--scroll-end", `-${percentage}%`)
  }
}
